import { Injectable, inject } from '@angular/core';

import { BehaviorSubject } from 'rxjs';

import { BackendError, RestErrorType } from '../../domain/error.domain';
import { RestApplicationErrorHandlerService } from '../rest/rest-handlers/rest-application-error-handler.service';
import { SYSTEM_STATUS_CONFIGURATION } from './system-status.contract';
import { SystemStatus, SystemStatusConfiguration } from './system-status.domain';

export { SYSTEM_STATUS_CONFIGURATION } from './system-status.contract';

@Injectable({
  providedIn: 'root'
})
export class SystemStatusService {
  private readonly configuration = inject<SystemStatusConfiguration>(SYSTEM_STATUS_CONFIGURATION);
  private readonly restApplicationErrorHandlerService = inject(RestApplicationErrorHandlerService);

  readonly onSystemStatusChange: BehaviorSubject<SystemStatus>;

  private readonly systemDownErrorCode: string;
  private systemStatus: SystemStatus;
  private firstStartAfterLogin: boolean;

  constructor() {
    this.systemStatus = this.configuration.systemStatus;
    this.firstStartAfterLogin = this.configuration.firstStartAfterLogin;
    this.systemDownErrorCode = this.configuration.systemDownErrorCode;

    this.onSystemStatusChange = new BehaviorSubject<SystemStatus>(this.systemStatus);
    this.restApplicationErrorHandlerService.onCriticalApplicationError.subscribe((error: BackendError): void => {
      if (this.isSystemNotAvailableError(error)) {
        this.onSystemDown();
      }
    });
  }

  isSystemNotAvailableError(error: BackendError): boolean {
    return error.type === RestErrorType.APPLICATION && error.code === this.systemDownErrorCode;
  }

  onSystemDown(): void {
    this.setSystemAvailable(SystemStatus.DOWN);
    this.onSystemStatusChange.next(SystemStatus.DOWN);
  }

  isSystemAvailable(): boolean {
    return this.systemStatus === SystemStatus.AVAILABLE;
  }

  isSystemDown(): boolean {
    return this.systemStatus === SystemStatus.DOWN;
  }

  isMaintenanceMode(): boolean {
    return this.systemStatus === SystemStatus.MAINTENANCE;
  }

  isHighLoadMode(): boolean {
    return this.systemStatus === SystemStatus.HIGH_LOAD;
  }

  setSystemAvailable(systemAvailable: SystemStatus): void {
    this.systemStatus = systemAvailable;
  }

  isFirstStartAfterLogin(): boolean {
    return this.firstStartAfterLogin;
  }

  setFirstStartAfterLogin(firstStartAfterLogin: boolean): void {
    this.firstStartAfterLogin = firstStartAfterLogin;
  }

}
